module.exports = __webpack_public_path__ + "static/media/editPerfil.4e21c194.jpg";